<div class="header-component">
  <div class="header-wrapper">
    <div class="header-logo"></div>
    <div class="layout-user-profile">
      <app-layout-user-profile class="error-screen"></app-layout-user-profile>
    </div>
  </div>
</div>

<div class="container">
  <div class="content">
    <h1>403</h1>
    <p>Sem permissão para acessar</p>
    <span
      >Você não possui permissão para acessar esta página.
      <a href="/">Voltar para o Console</a></span
    >
    <div class="ilustration-container">
      <img
        class="ilustration"
        src="assets/images/illustration/cactus-drawing.gif"
        alt="404"
        width="298px"
        height="298px"
      />
    </div>
    <span><a href="https://lottiefiles.com/">Créditos ilustração</a></span>
  </div>
</div>
